import {
  DEFAULT_TOKEN_DECIMALS,
  MAX_FRACTION_DIGITS,
  ADDRESS_FORMAT_START_LENGTH,
  ADDRESS_FORMAT_END_LENGTH,
  HASH_DISPLAY_LENGTH,
} from '@/constants/main'

export function formatAddress(
  address: string,
  startLength: number = ADDRESS_FORMAT_START_LENGTH,
  endLength: number = ADDRESS_FORMAT_END_LENGTH
): string {
  if (!address) return ''
  if (address.length <= startLength + endLength) return address
  return `${address.slice(0, startLength)}...${address.slice(-endLength)}`
}

export function formatHash(
  hash: string,
  length: number = HASH_DISPLAY_LENGTH
): string {
  if (!hash) return ''
  if (hash.length <= length) return hash
  return `${hash.substring(0, length)}...`
}

export function formatHashShort(hash: string, endLength: number = 6): string {
  if (!hash) return ''
  if (!hash.startsWith('0x')) return hash
  if (hash.length <= endLength + 2) return hash
  return `0x...${hash.slice(-endLength)}`
}

export function formatTokenBalance(
  rawBalance: bigint,
  decimals: number = DEFAULT_TOKEN_DECIMALS,
  symbol?: string
): string {
  const divisor = 10n ** BigInt(decimals)
  const intPart = (rawBalance / divisor).toString()
  const fracPartRaw = (rawBalance % divisor).toString().padStart(decimals, '0')
  const fracPart = fracPartRaw.replace(/0+$/, '')
  const formatted = fracPart.length > 0 ? `${intPart}.${fracPart}` : intPart

  const formattedBalance = Number(formatted).toLocaleString(undefined, {
    maximumFractionDigits: Math.min(decimals, MAX_FRACTION_DIGITS),
  })

  return symbol ? `${formattedBalance} ${symbol}` : formattedBalance
}

export function isValidEthereumAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(address)
}

export function formatDate(dateString: string): string {
  if (!dateString) return ''
  try {
    const date = new Date(dateString)
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return dateString
  }
}
